import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TreeFormComponent } from '../tree-form/tree-form.component';
import { TreeNode } from '../../../data/models/interfaces/tree-node.interface';
import { TreeFormData } from '../../../data/models/interfaces/tree-form-data.interface';

@Component({
  selector: 'app-button-tree-dialog',
  templateUrl: './button-tree-dialog.component.html',
  styleUrls: ['./button-tree-dialog.component.scss'],
})
export class ButtonTreeDialogComponent {
  @Input() text: string | undefined;
  @Input() dialogTitle: string | undefined;
  @Input() searchPlaceholder: string | undefined;

  dialogData: TreeFormData = { treeData: [] };

  @Input() treeSectors: TreeNode | undefined;
  @Input() treeProfiles: TreeNode | undefined;
  @Input() treeSegments: TreeNode | undefined;

  @Output() outputData = new EventEmitter<TreeNode[]>();

  constructor(public readonly dialog: MatDialog) {}

  openDialog() {
    this.pushTreeNodes();

    const dialogRef = this.dialog.open(TreeFormComponent, {
      data: this.dialogData,
      panelClass: ['dialog-custom'],
    });

    dialogRef.afterClosed().subscribe((result: TreeNode[]) => {
      if (result) {
        this.outputData.emit(result);
      }
    });
  }

  private pushTreeNodes() {
    this.dialogData.dialogTitle = this.dialogTitle
    this.dialogData.searchPlaceholder = this.searchPlaceholder

    this.dialogData.treeData = [];

    if (this.treeSectors) this.dialogData.treeData.push(this.treeSectors);

    if (this.treeProfiles) this.dialogData.treeData.push(this.treeProfiles);

    if (this.treeSegments) this.dialogData.treeData.push(this.treeSegments);
  }
}
